/**
 * Cart + drawer: edit "Gift Message" line item property via /cart/change.js.
 * Enhances rendered spans (ajaxcart__product-metas / ajaxcart__product-meta) that
 * start with "Gift Message:" so we do not need to change wpbingo Handlebars output.
 */
(function (window) {
  var GIFT_PREFIX = 'Gift Message:';
  var GIFT_KEY = 'Gift Message';
  var MAX = 200;
  var SEL_SPAN = 'span.ajaxcart__product-metas, span.ajaxcart__product-meta';
  var SEL_LINE = '.ajaxcart__product[data-line], .item-cart[data-line]';
  var CLS_WRAP = 'ajluxe-cart-gift-edit';
  var CLS_VIEW = 'ajluxe-cart-gift-edit__view';
  var CLS_ACTIONS = 'ajluxe-cart-gift-edit__actions';
  var CLS_ERR = 'ajluxe-cart-gift-edit__error';
  var pendingFrame = null;

  /* Write through the existing text node instead of replacing it: `textContent =`
     is a childList mutation, and Clarity's replay player applies the insert but
     not the remove, so the node replays holding every value it has ever held.
     nodeValue edits replay as one value. Full rationale and the canonical copy
     live in assets/ajluxe-cart-boost.js. */
  function setText(node, value) {
    if (!node) return;
    var first = node.firstChild;
    if (first && first.nodeType === 3 && !first.nextSibling) {
      if (first.nodeValue !== value) first.nodeValue = value;
      return;
    }
    node.textContent = value;
  }

  function t(key, fallback) {
    var c = window.ajluxeCartGift || {};
    return (c && c[key]) != null && c[key] !== '' ? c[key] : fallback;
  }

  function parseGiftText(text) {
    if (typeof text !== 'string') return { ok: false, value: '' };
    var s = text.trim();
    if (s.toLowerCase().indexOf('gift message:') !== 0) return { ok: false, value: '' };
    return {
      ok: true,
      value: s.slice(GIFT_PREFIX.length).replace(/^\s+/, '')
    };
  }

  function scheduleEnhance() {
    if (pendingFrame) return;
    pendingFrame = requestAnimationFrame(function () {
      pendingFrame = null;
      enhance();
    });
  }

  function changeGiftMessage(line, newValue) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (cart) {
        var n = parseInt(line, 10);
        if (isNaN(n) || n < 1) throw new Error('line');
        var item = cart.items[n - 1];
        if (!item) throw new Error('line');
        var props = Object.assign({}, item.properties || {});
        var trimmed = (newValue || '').trim().slice(0, MAX);
        if (trimmed) {
          props[GIFT_KEY] = trimmed;
        } else {
          delete props[GIFT_KEY];
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: n,
            quantity: item.quantity,
            properties: props
          })
        }).then(function (res) {
          if (!res.ok) throw new Error('change');
          return res.json();
        });
      });
  }

  function refreshCart() {
    var did = false;
    var wasDrawerOpen = document.body.classList.contains('drawer--open');
    if (wasDrawerOpen) {
      window.ajOpenDrawerAfterCartLoad = true;
    }
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
      did = true;
    }
    if (
      document.body.classList.contains('template-cart') &&
      window.ajaxCartPage &&
      typeof window.ajaxCartPage.load === 'function'
    ) {
      window.ajaxCartPage.load();
      did = true;
    }
    if (!did) {
      location.reload();
    }
  }

  function enhance() {
    var nodes = document.querySelectorAll(SEL_SPAN);
    for (var i = 0; i < nodes.length; i++) {
      var span = nodes[i];
      if (span.closest('.' + CLS_WRAP)) continue;
      var lineEl = span.closest(SEL_LINE);
      if (!lineEl) continue;
      var line = lineEl.getAttribute('data-line');
      if (!line) continue;
      var parsed = parseGiftText(span.textContent || '');
      if (!parsed.ok) continue;

      var val = parsed.value;
      var wrap = document.createElement('div');
      wrap.className = CLS_WRAP;
      wrap.setAttribute('data-ajluxe-gift-line', line);

      var view = document.createElement('div');
      view.className = CLS_VIEW;

      var label = document.createElement('span');
      label.className = span.className + ' ajluxe-cart-gift-edit__line';
      var inner = document.createElement('span');
      inner.className = 'ajluxe-cart-gift-edit__inner';
      var kicker = document.createElement('span');
      kicker.className = 'ajluxe-cart-gift-edit__kicker';
      kicker.textContent = t('label', 'Gift message');
      var valueEl = document.createElement('span');
      valueEl.className = 'ajluxe-cart-gift-edit__value';
      function setLabelView() {
        setText(valueEl, val || '');
      }
      setLabelView();
      inner.appendChild(kicker);
      inner.appendChild(valueEl);
      label.appendChild(inner);

      var editBtn = document.createElement('button');
      editBtn.type = 'button';
      editBtn.className = 'ajluxe-cart-gift-edit__btn';
      editBtn.setAttribute('aria-label', t('edit', 'Edit gift message'));
      editBtn.setAttribute('title', t('edit', 'Edit gift message'));
      var editIcon = document.createElement('i');
      editIcon.className = 'feather-edit-3';
      editIcon.setAttribute('aria-hidden', 'true');
      editBtn.appendChild(editIcon);

      var editor = document.createElement('div');
      editor.className = 'ajluxe-cart-gift-edit__editor';
      editor.setAttribute('hidden', '');

      var ta = document.createElement('textarea');
      ta.className = 'ajluxe-cart-gift-edit__textarea';
      ta.setAttribute('maxlength', String(MAX));
      ta.setAttribute('rows', '3');
      ta.setAttribute('aria-label', t('textarea', 'Gift message'));
      ta.value = val;

      var err = document.createElement('div');
      err.className = CLS_ERR;
      err.setAttribute('role', 'alert');
      err.hidden = true;

      var actions = document.createElement('div');
      actions.className = CLS_ACTIONS;

      var saveBtn = document.createElement('button');
      saveBtn.type = 'button';
      saveBtn.className = 'ajluxe-cart-gift-edit__save';
      saveBtn.textContent = t('save', 'Save');

      var cancelBtn = document.createElement('button');
      cancelBtn.type = 'button';
      cancelBtn.className = 'ajluxe-cart-gift-edit__cancel';
      cancelBtn.textContent = t('cancel', 'Cancel');

      function showView() {
        editor.setAttribute('hidden', '');
        view.removeAttribute('hidden');
        err.hidden = true;
        setText(err, '');
        setLabelView();
        wrap.classList.remove('is-updating');
        saveBtn.disabled = false;
        editBtn.disabled = false;
        cancelBtn.disabled = false;
      }

      function showEdit() {
        err.hidden = true;
        setText(err, '');
        view.setAttribute('hidden', '');
        editor.removeAttribute('hidden');
        ta.value = val;
        setTimeout(function () {
          try {
            ta.focus();
            ta.select();
          } catch (e) {}
        }, 0);
      }

      function setSaving(loading) {
        wrap.classList.toggle('is-updating', loading);
        saveBtn.disabled = loading;
        editBtn.disabled = loading;
        cancelBtn.disabled = loading;
      }

      editBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showEdit();
      });
      cancelBtn.addEventListener('click', function (e) {
        e.preventDefault();
        ta.value = val;
        showView();
      });
      saveBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setSaving(true);
        err.hidden = true;
        changeGiftMessage(line, ta.value)
          .then(function () {
            refreshCart();
          })
          .catch(function () {
            setText(err, t('error', 'Could not update. Please try again.'));
            err.hidden = false;
            setSaving(false);
          });
      });

      actions.appendChild(saveBtn);
      actions.appendChild(cancelBtn);
      editor.appendChild(ta);
      editor.appendChild(err);
      editor.appendChild(actions);
      view.appendChild(label);
      view.appendChild(editBtn);
      wrap.appendChild(view);
      wrap.appendChild(editor);

      span.replaceWith(wrap);
    }
  }

  function bindDrawerFooter() {
    if (window.jQuery) {
      window.jQuery(document).on('drawer.footer', scheduleEnhance);
    }
  }

  function observeCarts() {
    if (typeof window.MutationObserver === 'undefined') return;
    var list = document.querySelectorAll(
      '[data-cart-container], [data-cartpage-container], .js-drawer .drawer--cart, .content-cart_page'
    );
    for (var j = 0; j < list.length; j++) {
      (function (root) {
        if (root._ajluxeGiftObs) return;
        root._ajluxeGiftObs = true;
        var ob = new MutationObserver(function () {
          scheduleEnhance();
        });
        ob.observe(root, { childList: true, subtree: true });
      })(list[j]);
    }
  }

  function init() {
    bindDrawerFooter();
    observeCarts();
    scheduleEnhance();
    if (window.jQuery) {
      window.jQuery(function () {
        scheduleEnhance();
        observeCarts();
      });
    } else {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          scheduleEnhance();
          observeCarts();
        });
      } else {
        scheduleEnhance();
        observeCarts();
      }
    }
    setTimeout(scheduleEnhance, 500);
  }

  init();
})(this);
